import { GetStaticPaths } from 'next';

import { getAllCategorySlugs, getRedirectPaths } from '@api';
import Page from './page/[pageNo]';

export { getStaticProps } from './page/[pageNo]';

export const getStaticPaths: GetStaticPaths = async () => {
  const redirects = await getRedirectPaths();

  return {
    paths: (await getAllCategorySlugs())
      .map((slug) => `/knowledge/category/${slug}`)
      .filter((path) => !redirects.has(`${path}/`)),
    fallback: 'blocking',
  };
};

export default Page;
